import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../services/common.service';
import moment from 'moment';

@Component({
    selector: 'app-info-part',
    templateUrl: './info-part.component.html',
    styleUrls: ['./info-part.component.css'],
    standalone: false
})
export class InfoPartComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() hidetitle: Boolean;

  @Output() ibanBic = new EventEmitter<any>();

  default = 0;
  nbdigit;
  result: any[] = [];
  modepaie;
  modefacturejrxml;
  jours: any[] = [];
  typemodepaie;
  comm1;
  comm2;
  formspec;
  typeQteDASRI;
  site;
  siteCA;
  groupimp;
  typeflux;
  listCom = [];
  listNature = [];
  listAutorite = [];
  listFormspe = [];
  listQtedasri = [];
  listSite = [];
  listGrpimp = [];
  listTypeflux = [];
  listComptes = [];
  listCompte = [];
  listPrestation = [
    { id: 0, libelle: 'Depot' },
    { id: 1, libelle: 'Rotation' },
    { id: 2, libelle: 'Retrait' },
    { id: 3, libelle: 'Autre' },
    { id: 4, libelle: 'Location' },
    { id: 5, libelle: 'Forfait' },
  ];
  objAutorite = {};
  devise = '';
  listeAutoriteTemp = [];

  reglement: any = {};
  @ViewChild('prixPrestation') prixPrestation;
  @ViewChild('confirmationChorus') confirmationChorus;
  @ViewChild('msg') msg;
  error = '';
  cpatchaTextBox = '';
  code = '';
  montant : any = 0;

  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise || '€';
    this.listChamp();

  }

  listChamp() {
    this.typemodepaie = this.common.getItem(this.common.getType('typeModepaie'), (this.detail.modePaie || 0));
    this.listComptes = this.common.local.getObject('paramSociete').listCompte || [];

    this.searchNature();
    this.searchAutorite();
    if (this.detail['id']) {
      this.getMontant();
    }

    this.detail['dateNaissance'] = this.detail['dateNaissance'] ? moment(this.detail['dateNaissance'], 'DD/MM/YYYY').format('DD/MM/YYYY') : ''  ;
    this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite'] ? moment(this.detail['dateValiditeIdentite'], 'DD/MM/YYYY').format('DD/MM/YYYY') : '';
    this.detail['dateIdentite'] = this.detail['dateIdentite'] ? moment(this.detail['dateIdentite'], 'DD/MM/YYYY').format('DD/MM/YYYY') : '';
    this.detail['dateNaissanceModel'] = this.common.parseDate(this.detail['dateNaissance']);   
    this.detail['dateValiditeIdentiteModel'] = this.common.parseDate(this.detail['dateValiditeIdentite']);   
    this.detail['dateIdentiteModel'] = this.common.parseDate(this.detail['dateIdentite']);   
    if (this.detail['autoriteIdentite']) {
      this.objAutorite['id'] = this.detail['autoriteIdentite'];
      this.objAutorite['libelleObjetEntite'] = this.detail['autoriteIdentite'];
    }
    return true;
  }



  searchNature(event?) {
    this.listNature = [];
    const param = {
      'servlet': 'DBGetListNaturePiece',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetListNaturePiece']
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          const liste = datas.data || [];
          liste.forEach(element => {
            element.libelleObjetEntite = element.libelle || '';
          });
          this.listNature = [...liste];
        }
      }
    });
  }

  searchAutorite(event?) {
    this.listAutorite = [];
    const param = {
      'servlet': 'DBGetListValeurChampClient',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': ['autoriteIdentite']
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          const liste = datas.data.length && datas.data[0] ? datas.data[0] : [];
          liste.forEach(elt => {
            this.listAutorite.push({ id: elt, libelleObjetEntite: elt });
            this.listeAutoriteTemp.push({ id: elt, libelleObjetEntite: elt });
          });
        }
      }
    });
  }

  getMontant() {
    const param = {
      'servlet': 'DBGetMontantAnnuelPourClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          this.montant = parseFloat(datas.data).toFixed(2)
          // console.log(datas.data);
        }
      }
    });
  }


  getCompte(id) {
    const elem = this.listComptes.filter(elt => elt.id === id);
    return elem ? elem[0] : '';
  }

  Tofixed(value) {
    return parseFloat(value).toFixed(this.nbdigit);
  }

  searchCompte(event?) {
    this.listCompte = [];
    this.listComptes.forEach(elt => {
      // if (elt.numCompte.startsWith(event) || elt.numCompte.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = (elt.nomBanque ? elt.nomBanque + '/' : '') + elt.numCompte;
      this.listCompte.push(elt);
      // }
    });
  }

  showIBANBIC() {
    this.ibanBic.emit();
  }

  changeChampRecherche(event, element) {
    this.detail[element] = event;
    const ObjetList = {};
    let list = [];
    if (event !== '') {
      list = [...this.listeAutoriteTemp];
      this.listAutorite = [];
      list.forEach(elt => {
        elt.libelle = elt.libelleObjetEntite;
        if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
          elt.libelleObjetEntite = elt.libelle;
          this.listAutorite.push(elt)
        }
      });
    } else {
      list = [...this.listeAutoriteTemp];
      this.listAutorite = [];
      list.forEach(elt => {
        this.listAutorite.push(elt);
      });
    }
  }

  changeDateN(event, champ) {
    if (event && moment(event).isValid()) {
      this.detail[champ] = moment(event).format('DD/MM/YYYY');
    } else {
      this.detail[champ] = moment().format('DD/MM/YYYY');
    }
  }


}
